import React from 'react'
import { components } from 'react-select'

import type { BaseOptionType } from '../types'
import type { ControlProps } from 'react-select'

export const Control = <T,>(
  props: ControlProps<BaseOptionType<T>> & {
    selectProps?: { handleOpenMenu?: () => void; dataCy?: string }
  } & { innerProps?: { 'data-cy'?: string } }
) => {
  const {
    selectProps: { handleOpenMenu, dataCy },
  } = props
  return (
    <components.Control
      {...props}
      innerProps={{
        'data-cy': dataCy,
        ...props.innerProps,
        onClick: handleOpenMenu,
      }}
    />
  )
}
